import { IApplicationState } from '../../types/redux';

export function selectMoneyToSpend(state: IApplicationState) {
  return state.fieldsState.moneyToSpend;
}
